import { render, staticRenderFns } from "./Panel2.vue?vue&type=template&id=6dfb386c&scoped=true&"
import script from "./Panel2.vue?vue&type=script&lang=js&"
export * from "./Panel2.vue?vue&type=script&lang=js&"
import style0 from "./Panel2.vue?vue&type=style&index=0&id=6dfb386c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb386c",
  null
  
)

export default component.exports